import _mailboxes from "./mailboxes";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
var Mailboxes = _mailboxes;
/**
 * Expose `Helpscout`.
 */

exports = Helpscout;
/**
 * Initialize a new `Helpscout` client with an `apiKey`.
 *
 * @param {String} apiKey
 */

function Helpscout(apiKey) {
  if (!((this || _global) instanceof Helpscout)) return new Helpscout(apiKey);
  if (!apiKey) throw new Error("Helpscout requires an apiKey.");
  (this || _global).apiKey = apiKey;
  (this || _global).mailboxes = new Mailboxes(apiKey);
}

export default exports;